import { oc } from '@orpc/contract'
import { z } from 'zod'

export const drawingSchema = z.object({
  id: z.string().min(1),
  projectId: z.string().min(1),
  title: z.string(),
  slug: z.string(),
  createdAt: z.string(),
  updatedAt: z.string(),
  thumbnailUrl: z.string().nullable(),
})

export const drawingsListContract = oc
  .input(
    z.object({
      projectId: z.string().min(1),
    })
  )
  .output(
    z.object({
      items: z.array(drawingSchema),
    })
  )

export const drawingsGetContract = oc
  .input(
    z.object({
      projectId: z.string().min(1),
      drawingId: z.string().min(1),
    })
  )
  .output(
    z.object({
      drawing: drawingSchema,
      data: z.unknown(),
    })
  )

export const drawingsSaveContract = oc
  .input(
    z.object({
      projectId: z.string().min(1),
      drawingId: z.string().min(1).optional(),
      title: z.string().min(1).optional(),
      data: z.unknown(),
      thumbnailPngBase64: z.string().optional(),
    })
  )
  .output(drawingSchema)

export const drawingsDeleteContract = oc
  .input(
    z.object({
      projectId: z.string().min(1),
      drawingId: z.string().min(1),
    })
  )
  .output(
    z.object({
      success: z.boolean(),
    })
  )
